// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"567":"d247b72b","621":"99eafa77","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};